var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBroccoli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7004 12.3567C29.7004 13.8419 29.1104 15.2663 28.0602 16.3165C27.01 17.3667 25.5855 17.9567 24.1003 17.9567C22.7361 17.9651 21.4174 17.4661 20.4004 16.5567C19.7681 17.7406 18.8174 18.7242 17.6558 19.3965C16.4941 20.0688 15.1677 20.403 13.8262 20.3614C12.4846 20.3198 11.1815 19.904 10.0637 19.1611C8.94591 18.4181 8.05807 17.3775 7.50036 16.1567C6.95031 16.5603 6.28244 16.7712 5.60034 16.7567C5.12758 16.7567 4.65945 16.6635 4.22268 16.4826C3.78591 16.3017 3.38906 16.0365 3.05477 15.7022C2.72048 15.368 2.4553 14.9711 2.27438 14.5343C2.09346 14.0975 2.00036 13.6294 2.00036 13.1567C1.9902 12.4486 2.19503 11.7542 2.58782 11.165C2.98061 10.5758 3.54286 10.1196 4.20034 9.85666C4.03018 9.30702 3.96241 8.7308 4.00036 8.15667C4.00918 6.89453 4.40298 5.66514 5.12918 4.63281C5.85537 3.60048 6.87936 2.81437 8.06426 2.37954C9.24917 1.94472 10.5385 1.88188 11.7601 2.19944C12.9817 2.517 14.0772 3.19983 14.9004 4.15667C16.0628 3.31151 17.4631 2.8564 18.9004 2.85666C20.1588 2.85596 21.3877 3.23826 22.4237 3.95274C23.4597 4.66723 24.2538 5.68007 24.7004 6.85666C26.0707 6.98175 27.3444 7.61598 28.2701 8.63419C29.1957 9.6524 29.7061 10.9806 29.7004 12.3567Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1004 17.9565C24.1004 17.9565 19.2004 18.8565 19.2004 29.9565H14.1004C14.1004 29.9565 14.4004 22.2565 9.40039 18.5565",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroccoli);
export default __webpack_public_path__ + "static/media/broccoli.4afdc4be3305467973fde5bcdedcf1d2.svg";
export { ForwardRef as ReactComponent };